import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import LoadingModal from '@/components/modal/LoadingModal';
import setAlertValue from '@/components/alert';
import {
  CANDIDATES_ME_ROUTER_PATH,
  DEFAULT_CANDIDATES_ME_ROUTER_PATH,
} from '@/constants/router-path';
import { RESUME_EVALUATION_GROUP } from '@/constants/event-log';
import { trackClickEvent } from '@/utils/site-track';
import { createJobSeekerResume } from '@/api/tanzhi';

const CreateResume = ({
  isLogin,
  title,
  titleClassName,
}: {
  isLogin: boolean;
  title: string;
  titleClassName: string;
}) => {
  const [isCreating, setIsCreating] = React.useState(false);
  const router = useRouter();

  const handleCreate = (e: React.MouseEvent<HTMLButtonElement>) => {
    setIsCreating(true);
    trackClickEvent(e);
  };

  React.useEffect(() => {
    if (isCreating) {
      createJobSeekerResume()
        .then((res) => {
          if (res.status === 200) {
            setAlertValue({
              msg: '创建成功，即将跳转...',
              severity: 'success',
            });
            const data = res.data;
            router.push(`${CANDIDATES_ME_ROUTER_PATH}${data.id}`);
          }
        })
        .catch((error) =>
          setAlertValue({
            msg: error.response.data?.detail || '创建简历失败，请重试',
          }),
        )
        .finally(() => setIsCreating(false));
    }
  }, [isCreating]);

  return (
    <>
      {isLogin ? (
        <button
          className={`bg-transparent ${titleClassName}`}
          onClick={handleCreate}
          data-ele-id="btn_创建简历"
          data-ele-group={RESUME_EVALUATION_GROUP}
        >
          {title}
        </button>
      ) : (
        <Link
          className={titleClassName}
          href={DEFAULT_CANDIDATES_ME_ROUTER_PATH}
          data-ele-id="btn_创建简历"
          data-ele-group={RESUME_EVALUATION_GROUP}
          onClick={(e) => trackClickEvent(e, true)}
        >
          {title}
        </Link>
      )}
      <LoadingModal open={isCreating} />
    </>
  );
};

export default CreateResume;
